let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ivqOs")).then(() => parcelRequire('cce0v'));